import { isAuthor, ellipsisMultiline } from "../../../js/utils";

(() => {
  "use strict";
  const BRHParagraph = () => {
    const init = () => {
      if (!isAuthor()) {
        const paragraphs = document.querySelectorAll(".brh-paragraph.text");
        if (paragraphs.length === 0) {
          return;
        }

        paragraphs.forEach((paragraph) => {
          const p = paragraph.querySelector(".cmp-text .container__paragraph");

          const divParagraph = paragraph.querySelector(".cmp-text");
          const readMoreLink = divParagraph == null ? "" : divParagraph.querySelector(".brh-paragraph__readmore");
          const readLessLink = divParagraph == null ? "" : divParagraph.querySelector(".brh-paragraph__readless");

          const lineClamp = !readMoreLink || readMoreLink.getAttribute("data-lines-to-show") == "" ? "" : readMoreLink.getAttribute("data-lines-to-show");
          const showlabel = !readMoreLink || readMoreLink.getAttribute("data-read-label") == "" ? false : readMoreLink.getAttribute("data-read-label");

          if (showlabel) {
            readMoreLink.classList.remove("hidden");
            ellipsisMultiline(p, lineClamp);

            readMoreLink.addEventListener("click", () => {
              p.style.overflow = "unset";
              p.style.textOverflow = "unset";
              p.style.display = "unset";
              readMoreLink.classList.add("hidden");
              readLessLink.classList.remove("hidden");
            });

            readLessLink.addEventListener("click", () => {
              ellipsisMultiline(p, lineClamp);
              readMoreLink.classList.remove("hidden");
              readLessLink.classList.add("hidden");
            });
          }
        });
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHParagraph);
})();
